import Color from 'color';

import createInfoboxMarkup from '../../infobox/createInfoboxMarkup';

const getOptions = (filteredStateData, isTrend, dataKey) => {
  return {
    tooltip: {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      extraCssText: 'box-shadow: none',
      formatter: (info) => {
        const data = info.treePathInfo[1];
        if (!data) {
          return null;
        }
        const { value, dataIndex } = info.treePathInfo[1];
        const item = filteredStateData[dataIndex - 1];
        const trend = +item[dataKey].trend;

        const records = [{ name: 'Score', value }];
        isTrend && records.push({ name: 'Trend', value: trend });

        const tooltipTitle = item.label || item.domain;
        const tooltipSubtitle = item.companyName ? item.domain : '';

        return createInfoboxMarkup({
          title: tooltipTitle,
          subTitle: tooltipSubtitle,
          marker: { color: item.color },
          records,
        });
      },
    },
    series: [
      {
        type: 'treemap',
        animation: true,
        animationDuration: 1500,
        visibleMin: 300,
        width: '100%',
        height: '100%',
        left: 0,
        bottom: 0,
        top: 'auto',
        right: 'auto',
        roam: false,
        nodeClick: false,
        textStyle: {
          fontSize: 14,
        },
        label: {
          textFormatter: '{b}',
        },
        breadcrumb: {
          show: false,
        },
        itemStyle: {
          borderColor: null,
          borderWidth: 0,
          gapWidth: 5,
        },
        levels: [
          {
            color: filteredStateData.map(({ color, inFocus, myCompany }) => lightenIfTrue(color, inFocus || myCompany)),
          },
        ],
        data: filteredStateData.map(({ x, y }, index) => ({
          id: x,
          value: y,
          name: filteredStateData[index].label || x,
        })),
      },
    ],
  };
};

const lightenIfTrue = (hex, lighten) => {
  return !lighten ? hex : Color(hex).lighten(0.2).hex().toString();
};

export default getOptions;
